import { createFileRoute } from "@tanstack/react-router";
import AdminUsersPage from "@/admin/pages/users";

const TABS = ["all", "active", "locked", "pending_deletion", "deleted", "admins", "test"] as const;
type AdminUsersTab = (typeof TABS)[number];

type AdminUsersSearch = {
  tab?: AdminUsersTab;
  q?: string;
  last_name?: string;
  first_name?: string;
  birthday?: string;
  premium_only?: boolean;
};

// Trimmed here so the page never has to rewrite a URL it was just given.
const str = (v: unknown): string | undefined => {
  const t = typeof v === "string" ? v.trim() : "";
  return t || undefined;
};

export const Route = createFileRoute("/admin/users/")({
  component: AdminUsersPage,
  validateSearch: (search: Record<string, unknown>): AdminUsersSearch => {
    const tab = search.tab;
    return {
      tab: TABS.includes(tab as AdminUsersTab) ? (tab as AdminUsersTab) : undefined,
      q: str(search.q),
      last_name: str(search.last_name),
      first_name: str(search.first_name),
      birthday: str(search.birthday),
      premium_only:
        search.premium_only === true || search.premium_only === "true" ? true : undefined,
    };
  },
});
